export default "__VITE_ASSET__DYltbT0b__"